import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} ticketId
 * @return {Promise<Object>} Contacto
 */
export async function fetchRecordTicketClient(ticketId) {
  const url = `/contacts/clients/ticket/${ticketId}/`;
  const response = await httpManager.get(url);

  return response.data;
}
